<div class="policy" [class]="layout" (click)="select_policy()">
    <div *ngIf="layout === 'columns'">
        <div class="status">
            <span class="date">{{ policy.dates.start | date: 'dd/MM/yyyy' }}</span>
            <span class="status_name" [class]="get_class_by_name()">{{ policy.status.name }}</span>
        </div>
        <div class="client">
            <span>{{ policy.client.fullname }}</span>
            <span class="policy-number">{{ policy.policy?.data.numeroPoliza }}</span>
        </div>
        <div class="quotation">
            <div class="object-data">
                <mat-icon [svgIcon]="policy.object.icon"></mat-icon>
                <span>{{ policy.object.name }}</span>
            </div>
            <div class="quotation_price">{{ policy.quotation?.price || policy.policy?.price | currency: 0 : '€' }}/año</div>
        </div>
    </div>
    <div *ngIf="layout === 'inline'">
        <div>{{ policy.client.fullname }}</div>
        <div class="object-data">
            <span>{{ policy.object.icon }}</span>
            <span>{{ policy.object.name }}</span>
        </div>
        <div class="quotation_price">{{ policy.quotation.price }} €/año</div>
        <div class="date">{{ policy.dates.start | date: 'dd/MM/yyyy' }}</div>
        <div>
            <div class="status_name" [class]="get_class_by_name()">{{ policy.status.name }}</div>
        </div>
    </div>
</div>